export const ExternalLinkEndpoints = {
  add: (slug: string) => `/rest/v1/external-links/slug/${slug}`,
  list: (slug: string) => `/rest/public/v1/external-links/slug/${slug}`,
  update: (id: string, slug: string) => `/rest/v1/external-links/${id}/slug/${slug}`,
  remove: (id: string, slug: string) => `/rest/v1/external-links/${id}/slug/${slug}`
}
